import { render, staticRenderFns } from "./package-tasks-widget.vue?vue&type=template&id=7f2066a1&"
import script from "./package-tasks-widget.vue?vue&type=script&lang=js&"
export * from "./package-tasks-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports